// scriptUtils.js

/**
 * Injects a script into the document head.
 * @param {string} src - The source URL of the script.
 * @param {string} id - The ID to assign to the script element.
 * @param {string} inlineScript - The inline script content to execute.
 */
export const injectScript = (src, id, inlineScript) => {
    // Create script element for external script
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    document.head.appendChild(script);

    // Create script element for inline script
    if (inlineScript) {
        const inlineScriptElement = document.createElement('script');
        inlineScriptElement.innerHTML = inlineScript;
        document.head.appendChild(inlineScriptElement);
    }
};

/**
 * Removes a script from the document head.
 * @param {string} id - The ID of the script element to remove.
 */
export const removeScript = (id) => {
    const existingScript = document.getElementById(id);
    if (existingScript) {
        document.head.removeChild(existingScript);
    }
};
